import React, {useState} from 'react';
import {Col, Row} from 'reactstrap';

import RequestMapForm from "./_form";
import RequestMapList from "./_list";
import {ButtonNew} from "../../../components/buttons/buttonsActions";


export default function RequestMap(){

    const [collapseForm, setCollapseForm] = useState(false);
    const [editMode, setEditMode] = useState(false);
    const [item, setItem] = useState();

    const toggleForm = () => {
        setEditMode(false);
        setCollapseForm(!collapseForm);
        setItem(null);
    }

    const beginEdit = (data) => {
        setEditMode(true);
        setCollapseForm(!collapseForm);
        setItem(data);
    }

    return (
        <div>
            {/*--------------------------------------------------------------------------------*/}
            {/* Header*/}
            {/*--------------------------------------------------------------------------------*/}
            <Row>
                <Col md="12">
                    <div className="d-flex align-items-center">
                        {
                            !collapseForm &&
                                <div className="ml-auto paddingAdd">
                                    <ButtonNew onClick={toggleForm}/>
                                </div>
                        }
                    </div>
                </Col>
            </Row>
            {/* --------------------------------------------------------------------------------*/}
            {/* Listado*/}
            {/* --------------------------------------------------------------------------------*/}
            <Row>
                <Col md="12">
                    {!collapseForm && <RequestMapList beginEdit={beginEdit}/>}
                </Col>
            </Row>
            {/* --------------------------------------------------------------------------------*/}
            {/* Formulario*/}
            {/* --------------------------------------------------------------------------------*/}
            <Row>
                <Col md="12">
                    {collapseForm && <RequestMapForm toggleParent={toggleForm} item={item}/>}
                </Col>
            </Row>
        </div>
    );
}
